import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  ArrowLeft, ArrowRight, DotSelected, DotUnselected,
} from '../../../shared/svg/components';
import { setPopupState, updateCurrentCameraShot } from '../../../model/configuratorSlice';
import { PopupState } from '../../../model/constants';

const PlayerControls = ({ isMobileLandscape }) => {
  const currentShot = useSelector(state => state.configurator.currentShot);
  const currentShots = useSelector(state => state.configurator.currentShots);
  const currentCameras = useSelector(state => state.configurator.currentCameras);
  const dispatch = useDispatch();
  const location = useLocation();
  const isDescargasRoute = location.pathname.endsWith('/descargas');
  const [selectedShot, setSelectedShot] = useState(0);
  const [leftArrowEnabled, setLeftArrowEnabled] = useState(false);
  const [rightArrowEnabled, setRightArrowEnabled] = useState(false);

  const updateSelectedShot = (countShot) => {
    setSelectedShot(countShot);
  };

  const updateArrows = (countShot) => {
    setLeftArrowEnabled(countShot > 0);
    setRightArrowEnabled(countShot < currentShots.length - 1);
  };

  useEffect(() => {
    let countShots = 0;
    currentShots.forEach((shot) => {
      if (shot === currentShot) {
        updateSelectedShot(countShots);
        updateArrows(countShots);
      }
      countShots += 1;
    });
  }, [currentShot, currentShots]);

  const leftArrowClicked = (e) => {
    if (e && e.button !== 0) return;
    const nextShot = currentShots[selectedShot - 1];
    const nextCamera = currentCameras[selectedShot - 1];
    dispatch(updateCurrentCameraShot({ camera: nextCamera, shot: nextShot }));
  };
  const rightArrowClicked = (e) => {
    if (e && e.button !== 0) return;
    const nextShot = currentShots[selectedShot + 1];
    const nextCamera = currentCameras[selectedShot + 1];
    dispatch(updateCurrentCameraShot({ camera: nextCamera, shot: nextShot }));
  };
  const dotClicked = (clickedDot, e) => {
    if (e && e.button !== 0) return;
    const nextShot = currentShots[clickedDot];
    const nextCamera = currentCameras[clickedDot];
    dispatch(updateCurrentCameraShot({ camera: nextCamera, shot: nextShot }));
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => rightArrowClicked(),
    onSwipedRight: () => leftArrowClicked(),
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const openLegalNoteHandler = (e) => {
    if (e && e.button !== 0) return;
    dispatch(setPopupState(PopupState.LegalNote));
  };

  return (
    <div className={`player-controls${isDescargasRoute ? ' descargas' : ''}`} {...handlers}>
      <button
        className={`arrow-left-button${leftArrowEnabled ? '' : ' disabled'}`}
        type="button"
        onClick={leftArrowClicked}
      >
        <ArrowLeft />
      </button>
      <button
        className={`arrow-right-button${rightArrowEnabled ? '' : ' disabled'}`}
        type="button"
        onClick={rightArrowClicked}
      >
        <ArrowRight />
      </button>
      <div className="dots">
        {currentShots.map((shot, index) => (
          <button
            key={shot}
            className={`dot ${index === selectedShot ? 'selected' : ''}`}
            type="button"
            onClick={e => dotClicked(index, e)}
          >
            {index === selectedShot ? <DotSelected className="selected-color" /> : <DotUnselected />}
          </button>
        ))}
      </div>
      {!isMobileLandscape && (
        <button type="button" onClick={openLegalNoteHandler} className="legal-note">
          <span>Nota Legal</span>
        </button>
      )}
    </div>
  );
};

PlayerControls.propTypes = {
  isMobileLandscape: PropTypes.bool.isRequired,
};

export default PlayerControls;
